export default "__VITE_ASSET__CgYb7yrf__"